import React from "react";
import { MessageInterface, ApiHelper, NavigationHelper, PendingCommand, TemplateInterface, UserHelper, DateHelper, ArrayHelper } from "../../helpers";
import { Row, Col, FormControl, FormGroup, FormLabel, FormCheck } from "react-bootstrap"
import { InputBox, Loading, ErrorMessages, SavedMessage, } from "../../components"
import { Link, Redirect } from "react-router-dom";
import { MessageAnswers } from ".";
import ReactSelect from 'react-select'

interface Props {
  message: MessageInterface,
  template: TemplateInterface,
  refreshSidebar: () => void,
  refreshPage: () => void,
  pendingCommand: PendingCommand,
  sendCommand: (cmd: PendingCommand) => void,
  isLoading: boolean,
}

type OptionType = {
  value: string;
  label: string;
};

export const MessageEdit: React.FC<Props> = props => {
  const [message, setMessage] = React.useState<MessageInterface>(null);
  const [errors, setErrors] = React.useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [savedKey, setSavedKey] = React.useState("");
  const [redirect, setRedirect] = React.useState("");
  const [answersCommand, setAnswersCommand] = React.useState<PendingCommand>(null);
  const [submitProgress, setSubmitProgress] = React.useState(0);
  const [categoryInput, setCategoryInput] = React.useState("");

  const [categoryOptions, setCategoryOptions] = React.useState<OptionType[]>([{ value: "Test", label: "Test" }]);

  const handleCategoryChange = (newValue: { label: string, value: string }, obj: any) => {
    console.log(newValue);
    let m: MessageInterface = { ...message };
    m.category = newValue.value;
    setCategoryInput("");
    setMessage(m);
  }

  const handleCategoryBlur = () => {
    if (categoryInput) {
      const options = [...categoryOptions]
      options.push({ value: categoryInput, label: categoryInput })
      let m: MessageInterface = { ...message };
      m.category = categoryInput;
      setCategoryOptions(options);
      setMessage(m);
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let m: MessageInterface = { ...message };
    let val = e.currentTarget.value;
    switch (e.currentTarget.id) {
      case "name": m.name = val; break;
      case "category": m.category = val; break;
      case "seconds": m.seconds = parseInt(val, 0); break;
      case "crossDepartment":
        const chk: any = document.getElementById('crossDepartment');
        m.crossDepartment = chk.checked;
        break;
      case "isPublic":
        const publicCheck: any = document.getElementById('isPublic');
        m.isPublic = publicCheck.checked;
        break;
    }
    setMessage(m);
  }

  const validate = () => {
    let result: string[] = [];
    if (message.name === "") result.push("Please enter a message name.");
    if (message.seconds < 5) result.push("Messages must be displayed for at least 5 seconds");
    setErrors(result);
    return result.length === 0;
  }

  const handleSave = () => {
    if (validate()) {
      setIsSubmitting(true);
      message.name = message.name.trim();
      message.category = message.category.trim();
      ApiHelper.post("/messages", [message]).then((data: MessageInterface[]) => {
        setAnswersCommand({ action: "save", parameter: data[0].id.toString() });
      });
    }
  }

  const getDeleteFunction = () => (message?.id > 0) ? handleDelete : undefined

  const handleDelete = () => {
    if (window.confirm("Are you sure you wish to permanently delete this message?")) {
      ApiHelper.delete("/messages/" + message.id).then(() => {
        props.refreshSidebar();
        setRedirect("/messages");
      });
    }
  }

  /*
  const messagesSaved = () => {
    setIsSubmitting(false);
    props.refreshSidebar();
    setSavedKey(NavigationHelper.getRefreshKey());
  }
*/

  const answersSaved = (messageId: number) => {
    setIsSubmitting(false);
    props.refreshSidebar();
    setSavedKey(NavigationHelper.getRefreshKey());
    if (window.location.href.indexOf("/messages/0?") > -1) {
      setRedirect("/messages/" + messageId + "?shape=" + message.shape);
    } else if ([3, 11, 14, 15].indexOf(message.templateId) > -1) {
      setTimeout(() => {
        props.refreshPage();
      }, 500)
    }
  }


  const handleAnswersCommand = (cmd: PendingCommand) => {
    if (cmd.action === "updateProgress") setSubmitProgress(cmd.parameter);
    else props.sendCommand(cmd); //updatePreview
  }


  const getAnswers = () => {
    return <MessageAnswers message={message} pendingCommand={answersCommand} saveCallback={answersSaved} sendCommand={handleAnswersCommand} />
  }


  const handleParentCommand = () => {
    if (props.pendingCommand) {
      if (props.pendingCommand.action === "updateAnswer" || props.pendingCommand.action === "updateArrayAnswer") setAnswersCommand(props.pendingCommand);
    }
  }

  const getHeader = () => {
    let items: JSX.Element[] = [];

    if (message?.lastModified) items.push(<span style={{ fontStyle: "italic", fontWeight: "lighter", fontSize: 12 }}>Last updated: {DateHelper.getDisplayDuration(DateHelper.convertToDate(message.lastModified))}</span>)

    if (message.templateId === 7 && message.id > 0) {
      let copyLink = "/messages/0?templateId=7&copyFrom=" + message.id
      if (message?.shape === "9:16") copyLink += "&shape=" + message.shape;
      items.push(<Link to={copyLink} className="btn btn-info btn-sm">Copy</Link>);
    }
    return items;
  }

  const getChecks = () => {
    const result: JSX.Element[] = [];
    if (UserHelper.checkAccess("admin")) {
      result.push(
        <FormGroup key="publicCheck" className="mb-3">
          <FormCheck id="isPublic" type="checkbox" label="Make Public" onChange={handleChange} checked={message?.isPublic} />
        </FormGroup>
      );
    }
    if (UserHelper.departments.length > 1) {
      result.push(
        <FormGroup key="crossDepartmentCheck" className="mb-3" controlId="formBasicCheckbox">
          <FormCheck id="crossDepartment" type="checkbox" label="Show in all departments" onChange={handleChange} checked={message?.crossDepartment} />
        </FormGroup>
      );
    }
    return result;
  }


  React.useEffect(handleParentCommand, [props.pendingCommand]);
  React.useEffect(() => {
    setMessage(props.message);
    setIsSubmitting(false);
    setErrors(null);
    if (redirect) setRedirect("");

    ApiHelper.get("/messages").then((data) => {
      const cats = ArrayHelper.getStrings(data, "category");
      let options: OptionType[] = [];
      cats.forEach(c => {
        if (c) options.push({ value: c, label: c })
      });
      setCategoryOptions(options);
/*
      let m: MessageInterface = { ...message };
      if (!m.id && options.length>0) {
        m.category = options[0].value
        setMessage(m);
      }
*/
      
    });
  }, [props.message]);  //eslint-disable-line


  if (redirect !== "") return <Redirect to={redirect} />
  else if (!message) return <Loading />
  else {
    let saveText = "Save";
    if (props.isLoading) saveText = "Loading...";
    if (isSubmitting) saveText = "Saving...";

    const categoryOption = (message?.category === "" && categoryOptions.length > 0) ? categoryOptions[0] : { value: message.category, label: message.category }


    return (
      <InputBox headerIcon="fas fa-list-ul" headerText="Edit Message" saveFunction={handleSave} saveText={saveText} isSubmitting={isSubmitting || props.isLoading} submitProgress={submitProgress} deleteFunction={getDeleteFunction()} headerActionContent={getHeader()} >
        <SavedMessage refreshKey={savedKey} />
        <ErrorMessages errors={errors} />
        {getChecks()}
        <Row>
          <Col>
            <FormGroup>
              <FormLabel htmlFor="template">Template</FormLabel>
              <FormControl id="template" value={props.template?.name || ""} disabled={true} />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <FormLabel htmlFor="seconds">Duration (in seconds)</FormLabel>
              <FormControl id="seconds" value={(props.template?.id === 11) ? "Determined by video" : message.seconds || ""} disabled={props.template?.id === 11} onChange={handleChange} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <FormLabel htmlFor="category">Category <span style={{fontSize:10}}>(Type in value to create a new category)</span></FormLabel>
              <ReactSelect onInputChange={(newValue: string) => { setCategoryInput(newValue) }}
                value={categoryOption}
                onChange={handleCategoryChange}
                options={categoryOptions}
                onBlur={handleCategoryBlur}
              />
            </FormGroup>

          </Col>
          <Col>
            <FormGroup>
              <FormLabel htmlFor="name">Name</FormLabel>
              <FormControl id="name" value={message.name} onChange={handleChange} />
            </FormGroup>
          </Col>
        </Row>
        {getAnswers()}
      </InputBox >
    );
  }
}
